import {useState} from '#imports';

export function useDataLayer() {
    return useState<Record<string, any>>('dataLayer', () => ({}));
}
